import {
  Button,
  // Callout,
  Classes,
  // ControlGroup,
  Dialog,
  // FormGroup,
  HTMLTable,
  Icon,
  Intent,
  Spinner
  // Tag,
  // TextArea,
} from "@blueprintjs/core";
import { Timestamp } from "@firebase/firestore-types";
import { Users } from "@just-in-types";
import * as React from "react";
import firebase from "../../../firebase";
import { firestore } from "../../../firebase";
import TimestampFunc = firebase.firestore.Timestamp;
// import { IStrings } from "../store/reducers/strings";
import { strings } from "../../../store/reducers/strings";
// import "../styles/inputmobile.css";
import Notifications from "../../../views/Notifications";
// import VehicleModal from "../../../components/VehicleModal";
interface Props {
  checkIn: Users.CheckIn;
  handleAddNewPics:any;
}


interface VehiclePick {
  docId: string;
  businessId: string;
  combined: string;
  firstName: string;
  make: string;
  mobile: string;
  model: string;
  remainDays?: number;
  siteId: string;
  textSent: boolean;
  timestamp?: null | Timestamp;
  userId: string;
  yearMax: number;
  yearMin: number;
  matches?: any;
}

interface State {
  businessDoc: any;
  isOpen: boolean;
  loading: boolean,
  logo: null | string;
  matches: any;
  mobile: string;
  picks: VehiclePick[];
  rowSelected: null | number;
  showVehicleBlock: boolean;
  showVehicleModal: boolean;
}
const hoverRow = {
  cursor: "hand",
  fontSize: "16px",
};

const getMatchesForVehicle = firebase.functions().httpsCallable("getMatchesForVehicle");



class VehiclesDialog extends React.Component<Props, State> {
  public welcomeInstructions = (
    <tr >
      <td />
      <td>{strings.welcomeInstructions}</td>
      <td>&nbsp;</td>
    </tr>
  );


  constructor(props: Props) {
    super(props);
    this.state = {
      businessDoc: null,
      isOpen: false,
      loading: false,
      logo: null,
      matches: null,
      mobile: "",
      picks: [],
      rowSelected: null,
      showVehicleBlock: false,
      showVehicleModal: false,
    };
  }

  public componentDidUpdate({ checkIn: prevCheckIn }: Props) {
    const { checkIn } = this.props;
    if (prevCheckIn.checkInId !== checkIn.checkInId) {

      if(checkIn.mobile){
        this.setState({ mobile : checkIn.mobile });
      }

      firestore
        .collection("businesses")
        .where("path", "==", checkIn.businessPath)
        .get()
        .then((snap) => {
          this.setState({
            businessDoc: snap.docs[0].data(),
            logo: snap.docs[0].data().theme.logo
          });
      });

      if(checkIn.mobile && checkIn.businessPath && checkIn.sitePath){
        this.watchPicks(checkIn.mobile, checkIn.businessPath, checkIn.sitePath);
      }

    }
  }

  public render() {
    const { isOpen, } = this.state;
    const dialogProps: Dialog["props"] = {
      canEscapeKeyClose: true,
      canOutsideClickClose: true,
      isOpen,
      onClose: this.toggleModal,
      title: "Just In text alerts",
    };
    return (
      <>
        <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} style={{ background:"#0D8050",marginBottom: "0.5rem" }} onClick={this.toggleModal}>
        {/* <Button style={{ background:markUserNotes?"#9B9B9B":"#0D8050",marginBottom: "0.5rem" }} onClick={this.toggleModal}> */}
          Add/Edit Vehicle Picks
        </Button>
        {/* {markUserNotes?(
          <span className="left-side-undo-icon">
            <Button icon="undo" style={{background:"#9B9B9B",marginBottom:"10px",marginLeft:"10px"}} onClick={this.undoMarkUserNotes} />
          </span>
        ):
          ("")
        } */}

        <Dialog {...dialogProps}>
          <div className={Classes.DIALOG_BODY}>
          <div style={{ float:'right', display:this.state.showVehicleBlock?'none':'block' }}>
            <Button
              large={true}
              intent='primary'
              onClick={this.editPicks}
            >
              {"Edit Picks"}
            </Button>  
          </div>
          <br />
          <br />
          <div style={{ display:this.state.showVehicleBlock?'none':'block' }}>
              <Notifications
                businessId={this.props.checkIn.businessId}
                siteId={this.props.checkIn.siteId && this.props.checkIn.siteId !== "" ? this.props.checkIn.siteId : null}
                toggleLanguage={()=>{'eng'}}
                language={this.props.checkIn.language}
                mobile={this.state.mobile}
                // @ts-ignore
                setNextClicked={(click) => (this.clickChild = click)}
                welcomeFlow={true}
                strings={strings.eng}
                displayBtn = {false}
              />
              <div>
                <p style={{ fontSize: "13pt" }}>{strings.enterMobile}</p>
              </div>
              <div style={{ textAlign : "center" }}>
                <input
                  name="mobile"
                  value={this.state.mobile}
                  onChange={(event) => this.onChange(event)}
                  size={10}
                  style={{  outline: "none" }}
                />
              </div>
              <div style={{ textAlign : "center" }}>
                <Button
                  disabled={this.state.mobile.length !== 10}
                  large={true}
                  intent="success"
                  onClick={(event) => {
                    // @ts-ignore
                    this.clickChild();
                    this.handleMobileInput(this.state.mobile);
                  }}
                  icon="log-in"
                >
                  {"Next"}
                </Button>
              </div>
            </div>
            {/* <VehicleModal
              show={this.state.showVehicleModal}
              strings={'eng'}
              handleClose={() => this.setState({ showVehicleModal: false })}
              vehicle={this.state.vehicle}
              vehicleUrl={businessDoc.vehicleUrl}
            /> */}

          <div style={{ display:this.state.showVehicleBlock?'block':'none' }}>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                justifyContent: "center",
                margin: "0 auto",
                width: "100%",
              }}
            >
              {this.state.loading ? (
                <Spinner />
              ) :('')}
              <HTMLTable>
                <thead>
                  <tr>
                    <th />
                    <th>{"My Picks"}</th>
                    <th>{"New"}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.picks.length === 0
                    ? this.welcomeInstructions
                    : this.state.picks.map((pick, index) => this.renderPickRow(pick, index))}
                </tbody>
              </HTMLTable>
            </div>
          </div>


          </div>
        </Dialog>
      </>
    );
  }

  private editPicks = () => {
    this.setState({ showVehicleBlock : true });
  }

  private renderPickRow = (pick: VehiclePick, index: number) => {
    let fetchingInfo: boolean = false;
    let isFresh: boolean = false;
    let isFreshIcon;
    if (pick.matches === null) {
      fetchingInfo = true;
      isFresh = false;
      isFreshIcon = <Icon className="icon-spin" icon="refresh" iconSize={20} />;
    } else if (pick.matches.length === 0) {
      isFresh = false;
      isFreshIcon = <Icon icon="unknown-vehicle" iconSize={25} intent={Intent.DANGER} />;
    } else {
      isFresh = true;
      isFreshIcon = <Icon icon="known-vehicle" iconSize={25} intent={Intent.SUCCESS} />;
    }

    const remainDays =
      this.state.businessDoc.showPickLeft !== false ? (
        <span style={{ fontSize: "10px" }}>{pick[`remainDays`]}d left</span>
      ) : (
        ""
      );

    const deletePick = (
      <Icon onClick={() => this.deletePick(pick, index)} icon="delete" iconSize={20} intent={Intent.DANGER} />
    );

    const renewPick = (
      <Icon onClick={() => this.renewPick(pick, index)} icon="automatic-updates" iconSize={20} intent={Intent.SUCCESS} />
    );

    const text = pick.yearMin + "-" + pick.yearMax + " " + pick.combined;
    // if (this.state.rowSelected === index) {
    //   console.log("state: " + this.state.rowSelected + " index: " + index);
    // }

    return (
      <tr className={this.state.rowSelected === index ? "bordered" : ""} style={hoverRow} key={index}>
        <td>{deletePick}</td>
        <td onClick={() => this.handlePickSelected(pick, index)}>{text}</td>
        <td>
          {isFreshIcon} <br /> {remainDays} <br /> {this.isNewText(fetchingInfo, isFresh)}
        </td>
        <td>{renewPick}</td>
      </tr>
    );
  };
  private handlePickSelected = async (pick: VehiclePick, index: number) => {
    // console.log("finding " + pick.combined);
    // console.log(pick);
    this.setState({ matches: pick.matches, rowSelected: index });
    // console.log(this.state);
  };

  private isNewText = (fetchingInfo: boolean, isFresh: boolean) => {
    if (fetchingInfo) {
      return "";
    }

    if (isFresh) {
      return <p style={{ fontSize: "9px" }}>New Vehicle</p>;
    } else {
      return <p style={{ fontSize: "9px" }}>No New Vehicle</p>;
    }
  };


  private deletePick = async (pick: VehiclePick, index: number) => {
    const { picks } = this.state;
    const { mobile } = this.props.checkIn;

    const docQuery = await firestore
      .collection("vehiclePicks")
      .doc(pick.docId)
      .get();

    if (docQuery.exists) {
      docQuery.ref.delete();
    }

    picks.splice(index, 1);

    this.setState({ picks });
    const res = await this.countMatchesDel(picks, mobile);
    this.props.handleAddNewPics(res);

  };

  private renewPick = async (pick: VehiclePick, index: number) => {
    const { picks } = this.state;

    const docQuery = await firestore
      .collection("vehiclePicks")
      .doc(pick.docId)
      .get();

    if (docQuery.exists) {

      const newTime = new Date().getTime();
      const newTimestamp : Timestamp = TimestampFunc.fromMillis(newTime);

      const pick2 = docQuery.ref;
      pick2.update({
        timestamp:newTimestamp
      }).then(()=> {
        picks[index].timestamp = newTimestamp;
        picks[index].remainDays = 90;
        this.setState({ picks });
      });
    }

  };


  private toggleModal = () =>{
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
    this.setState({ showVehicleBlock: false });
  }
    
   
    private onChange = (event) => {
      if (!isNaN(event.target.value) && event.target.value.length <= 10) {
        this.setState({ mobile: event.target.value });
      }
    };

    private watchPicks = async (mobile: string, business: string, site: string) => {
      let query;
      if (business) {
        const businessQuery = await firestore
          .collection("businesses")
          .where("path", "==", business)
          .get();
        let businessDoc;
        if (!businessQuery.empty) {
          businessDoc = businessQuery.docs[0].data();
          // console.log(businessDoc);
          if (businessDoc.theme && businessDoc.theme.logo) {
            this.setState({ logo: businessDoc.theme.logo });
          }
          if (businessDoc.s3Id || businessDoc.urgId || !site || site === "-") {
            query = await firestore
              .collection("vehiclePicks")
              .where("mobile", "==", mobile)
              .where("businessId", "==", businessDoc.businessId)
              .get();
          } else if (site && site !== "-") {
            const siteQuery = await businessQuery.docs[0].ref
              .collection("sites")
              .where("path", "==", site)
              .get();
            const siteDoc = await siteQuery.docs[0].data();
            const siteId = siteQuery.docs[0].id;
            if (siteDoc.theme && siteDoc.theme.logo) {
              this.setState({ logo: siteDoc.theme.logo });
            }
            if (siteDoc.s3Id || siteDoc.urgId) {
              query = await firestore
                .collection("vehiclePicks")
                .where("mobile", "==", mobile)
                .where("siteId", "==", siteId)
                .get();
            } else {
              query = await firestore
                .collection("vehiclePicks")
                .where("mobile", "==", mobile)
                .get();
            }
          } else {
            query = await firestore
              .collection("vehiclePicks")
              .where("mobile", "==", mobile)
              .get();
          }
        }
      } else {
        query = await firestore
          .collection("vehiclePicks")
          .where("mobile", "==", mobile)
          .get();
      }
  
      const picks:VehiclePick[]  = [];
      // const { picks } = this.state;
      await query.forEach((doc) => {
        const pick = doc.data() as VehiclePick;
        // console.log(doc.ref);
        pick.docId = doc.ref.id;
        pick.matches = null;
  
        if (pick.timestamp) {
          const timestampToDate = pick.timestamp.toDate();
          const diff = new Date().getTime() - new Date(timestampToDate).getTime();
          const delta = diff / 1000;
          const days = Math.floor(delta / 86400);
  

          const remainDays = 90 - (days > 90 ? 90 : days);
          // const remainDays = 90;
          pick.remainDays = remainDays;
          
        }
  
        picks.push(pick);  
        counter += 1;
      });
      this.setState({ picks });
      let counter = 0;
      
      // this.state.picks.forEach(async (pick) => {
      await picks.forEach(async (pick) => {
        this.findPickMatches(pick, counter);
        counter += 1;
      });
  
      this.setState({ showVehicleBlock : true });
    };

    private handleMobileInput = async (mobile: string) => {

      const { businessPath, sitePath } = this.props.checkIn;
      if(businessPath && sitePath){
        await this.watchPicks(mobile, businessPath, sitePath);
        this.countMatches(mobile);
      }

      
    };

    private countMatches = async (mobile) => {
      const { picks } = this.state;
      const res = { curMobile:mobile, pickLength:0, newInventory:0 };
      
      let count = 0;
      let oldCount = 0;
      let pickLength = 0;
      let newInventory = 0;
      picks.forEach(async ele=>{
        const result = await getMatchesForVehicle(ele);
        if( result.data !== null && result.data.length !== 0){
          count++;
        }

        if( result.data !== null && result.data.length === 0){
          oldCount++;
        }

        pickLength++;

        if(pickLength === picks.length){
          if(count){
            newInventory = 1;
          }
      
          if(count === 0 && oldCount > 0){
            newInventory = 2;
          }
    
          res.pickLength = pickLength;
          res.newInventory = newInventory;

          this.props.handleAddNewPics(res);
        }

      });


    }

    private countMatchesDel = async(picks, mobile) => {
      const res = { curMobile:mobile, pickLength:0, newInventory:0 };
      
      let count = 0;
      let oldCount = 0;
      let pickLength = 0;
      let newInventory = 0;
      picks.forEach(ele=>{
        if( ele.matches !== null && ele.matches.length !== 0){
          count++;
        }

        if( ele.matches !== null && ele.matches.length === 0){
          oldCount++;
        }

        pickLength++;
      });

      if(count){
        newInventory = 1;
      }
  
      if(count === 0 && oldCount > 0){
        newInventory = 2;
      }

      res.pickLength = pickLength;
      res.newInventory = newInventory;
  
      return res;
    }

    private findPickMatches = async (pick: VehiclePick, index: number) => {
      // console.log(pick);
      if (pick === undefined) {
        return;
      }
      const result = await getMatchesForVehicle(pick);
      // console.log(result);
      let matches = result.data;
      if (matches === null) {
        matches = [];
      }
      if(this.state.picks[index]){
        this.state.picks[index].matches = matches;
      }
      
      this.forceUpdate();
    };

}

export default VehiclesDialog;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/VehiclesDialog.tsx